import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { LOOKUP_PWS_OPERATORS } from "./waterServiceConnectionsConfig";

export const useWaterServiceConnectionLookups = () => {
  const { getAccessTokenSilently } = useAuth0();

  const { data: pwsOperators = [] } = useQuery(
    ["pws-operators"],
    async () => {
      const token = await getAccessTokenSilently();
      const { data } = await axios.get(LOOKUP_PWS_OPERATORS, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  return {
    pwsOperators,
  };
};
